import { FC } from "react";
import { BankIncomeSource, InstitutionMetadata } from "types/landlord/reports";
import { UniversalExpanderDataColumn } from "../../UniversalExpanderDataColumn";
import { getBankAccountMappings } from "../utils";
import { InstitutionLogo } from "../../InstitutionLogo";

type Props = {
  institution?: InstitutionMetadata;
  source?: BankIncomeSource;
};

export const BankAccountDetails: FC<Props> = ({ source }) => {
  const bankAccountData = getBankAccountMappings(
    source,
    source?.institutionMetaData
  );

  return (
    <div key={source?.account_id} className="flex flex-col gap-3">
      <UniversalExpanderDataColumn
        title=""
        data={bankAccountData.bankIncomeSourceMappings}
      />
      <UniversalExpanderDataColumn
        title="Verified via bank acount"
        data={bankAccountData.bankAccountMappings}
        subtitle={
          <div className="flex gap-4 items-center">
            {source?.institutionMetaData?.logo ? (
              <InstitutionLogo logo={source.institutionMetaData.logo} />
            ) : null}
            <div>
              <p className="text-sm font-medium text-content-1000">
                {source?.institutionMetaData?.name}
              </p>
            </div>
          </div>
        }
      />
    </div>
  );
};
